query GetMerchBoardDataById($merchOverlayId: ID!, $slug: String) {
  merchBoard: StreamToolsGetMerchBoardDataById(merchOverlayId: $merchOverlayId, slug: $slug) {
    channel
    config {
      merchOverlayId
      name
      storeTitle
      shopDomain
      items {
        productId
        title
        priceCents
        imageUrl
        linkUrl
      }
      createdAt
      updatedAt
    }
    board
  }
}
